import React, { useEffect, useRef, useState } from "react";

const Softwareabout = () => {
  const imageRef = useRef(null);
  const textRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (imageRef.current) observer.observe(imageRef.current);
    if (textRef.current) observer.observe(textRef.current);

    return () => {
      if (imageRef.current) observer.unobserve(imageRef.current);
      if (textRef.current) observer.unobserve(textRef.current);
    };
  }, []);

  return (
    <div className="industrial-container">
      <style>
        {`
          .industrial-container {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 40px 5%;
            background-color: white;
            flex-wrap: wrap;
          }
          .industrial-text {
            width: 50%;
            padding-left: 40px;
            text-align: left;
          }
          .industrial-title {
            font-size: 32px;
            font-weight: bold;
            margin-bottom: 20px;
            color: black;
            letter-spacing: 0px;
          }
          .industrial-desc {
            font-size: 16px;
            line-height: 1.6;
            margin-bottom: 15px;
            text-align: justify;
            color: black;
          }
          .industrial-image-section {
            width: 45%;
            text-align: center;
          }
          .industrial-image {
            width: 100%;
            max-width: 700px;
            height: auto;
            border-radius: 8px;
          }

          /* Animation styles */
          .slide-in-left {
            opacity: 0;
            transform: translateX(-50px);
            transition: all 1s ease-in-out;
          }
          .slide-in-right {
            opacity: 0;
            transform: translateX(50px);
            transition: all 1s ease-in-out;
          }
          .visible {
            opacity: 1;
            transform: translateX(0);
          }

          /* Responsive */
          @media (max-width: 1024px) {
            .industrial-title {
              font-size: 28px;
            }
            .industrial-desc {
              font-size: 15px;
            }
          }
          @media (max-width: 768px) {
            .industrial-container {
              flex-direction: column;
              padding: 20px;
            }
            .industrial-text {
              width: 100%;
              padding-left: 0;
              order: 2;
            }
            .industrial-image-section {
              width: 100%;
              order: 1;
              margin-bottom: 30px;
            }
            .industrial-title {
              font-size: 26px;
              text-align: center;
            }
            .industrial-desc {
              font-size: 14px;
              text-align: left;
            }
          }
          @media (max-width: 480px) {
            .industrial-title {
              font-size: 22px;
            }
            .industrial-desc {
              font-size: 13px;
            }
          }
        `}
      </style>

      {/* Image Section */}
      <div
        ref={imageRef}
        className={`industrial-image-section slide-in-left ${
          isVisible ? "visible" : ""
        }`}
      >
        <img
          src="/image/sofftware.webp"
          alt="Software and Digital Platforms"
          className="industrial-image"
        />
      </div>

      {/* Text Section */}
      <div
        ref={textRef}
        className={`industrial-text slide-in-right ${
          isVisible ? "visible" : ""
        }`}
      >
        <h2 className="industrial-title">
          Empowering Growth with Software and Digital Platforms
        </h2>
        <p className="industrial-desc">
          Software and digital platforms are the backbone of today’s connected
          world. They streamline operations, enable seamless collaboration, and
          drive innovation across industries by providing scalable, secure, and
          intelligent solutions.
        </p>
        <p className="industrial-desc">
          From enterprise applications and e-commerce platforms to cloud-based
          services, AI-driven analytics, and mobile-first solutions, digital
          platforms are transforming the way businesses operate and deliver
          value. They ensure agility, customer-centric experiences, and
          real-time decision-making.
        </p>
        <p className="industrial-desc">
          At Envision, we specialize in building robust software ecosystems and
          digital platforms that empower businesses to stay ahead. By leveraging
          cloud computing, automation, and next-generation development
          frameworks, we create solutions that are secure, scalable, and
          future-ready.
        </p>
      </div>
    </div>
  );
};

export default Softwareabout;
